/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DealCardTransactionEvidenceListInner } from './deal-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { DealIntegratedBy } from './deal-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { DealInvoiceIssuer } from './deal-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { DealJournalEntriesInner } from './deal-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { DealJournalizedBy } from './deal-journalized-by';

/**
 * 
 * @export
 * @interface Deal
 */
export interface Deal {
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'status': DealStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {DealJournalizedBy}
     * @memberof Deal
     */
    'journalizedBy': DealJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {DealIntegratedBy}
     * @memberof Deal
     */
    'integratedBy': DealIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Deal
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<DealJournalEntriesInner>}
     * @memberof Deal
     */
    'journalEntries': Array<DealJournalEntriesInner>;
    /**
     * 
     * @type {Array<DealCardTransactionEvidenceListInner>}
     * @memberof Deal
     */
    'cardTransactionEvidenceList': Array<DealCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof Deal
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Deal
     */
    'canSync': boolean;
    /**
     * 
     * @type {DealInvoiceIssuer}
     * @memberof Deal
     */
    'invoiceIssuer': DealInvoiceIssuer | null;
}

export const DealStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type DealStatusEnum = typeof DealStatusEnum[keyof typeof DealStatusEnum];


